// extracted by mini-css-extract-plugin
module.exports = {"module":"BaseModule-module_module_DTPm1","module__row":"BaseModule-module_module__row_1sj_X","module__row_window":"BaseModule-module_module__row_window_2pjoe"};